import { useEffect, useState } from "react";

export function usePlaceName(lat?: number, lon?: number) {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (lat == null || lon == null) return;
    const ctrl = new AbortController();

    const url = new URL("https://nominatim.openstreetmap.org/reverse");
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("lat", String(lat));
    url.searchParams.set("lon", String(lon));

    fetch(url.toString(), {
      signal: ctrl.signal,
      headers: { "Accept-Language": navigator.language || "en" },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((j: any) => {
        if (!j) return;
        const a: any = j.address || {};
        const locality = a.city || a.town || a.suburb || a.village || a.state || null;
        const country = a.country_code ? String(a.country_code).toUpperCase() : a.country || "";
        setName(locality ? `${locality}, ${country}` : country || null);
      })
      .catch(() => {});

    return () => ctrl.abort();
  }, [lat, lon]);

  return name;
}
